export default __webpack_public_path__ + "media/images/gallery/11-987412a2977fbd3af57603f295cc0299.jpg";